export default interface InvoiceMigratonDate{
    dateRangeFrom: Date;
    dateRangeTo: Date;
}

export const InvoiceMigrationDateProps: InvoiceMigratonDate = {
    dateRangeFrom: new Date(),
    dateRangeTo: new Date()
}